<div class="container-fluid">
  <div class="row">
    <app-display-counts-widget
      [widgetPanelCounts]="widgetPanelCounts"
      [title]="'Quality Control'"
    ></app-display-counts-widget>
  </div>
</div>
